// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__gtbHf","title":"ClientCherryInfo_title__3XC0q","itemText":"ClientCherryInfo_itemText__1EfaY"};